import { Chart } from "react-google-charts";

// Componente para mostrar una gráfica de barras con la lista recibida
export const BarChart: React.FC<{ list: any[] }> = ({ list }) => {
    return (
        <div style={{display:"block"}}>
            <Chart
                chartType="ColumnChart" // Tipo de gráfica: columnas
                width="100%" // Ancho completo del contenedor
                height={"400px"} // Alto fijo de la gráfica
                data={list} // Datos que se mostrarán en la gráfica
                options={{
                    chart: {
                        title: "Candidatos Seleccionados", // Título principal de la gráfica
                        subtitle: "", // Subtítulo vacío
                    },
                    chartArea: { width: '73%', height: '20px', top: "5%" }, // Área interna de la gráfica
                    fontSize: 10, // Tamaño de fuente general
                    legend:"none", // Oculta la leyenda
                }}
            />
        </div>
    );
}